(function () {
  "use strict";

  // French comparison labels; do not alter other locale copy or comparison logic.
  function frenchCopy(source, values) {
    var translations = {
      "Porovnanie produktov TERAVIA": "Comparaison des produits TERAVIA",
      "Vlastnosť": "Caractéristique",
      "Fotografia": "Photo",
      "Bez fotografie": "Sans photo",
      "Typ": "Type",
      "Cena": "Prix",
      "Výška": "Hauteur",
      "Šírka / priemer": "Largeur / diamètre",
      "Silueta": "Silhouette",
      "Akcia": "Action",
      "Otvoriť detail": "Voir le produit",
      "Odobrať": "Retirer",
      "Odobrať {title} z porovnania": "Retirer {title} de la comparaison",
      "Odobrať z porovnania": "Retirer de la comparaison",
      "Pridať do porovnania": "Ajouter à la comparaison",
      "V porovnaní sú už 4 produkty. Jeden najprv odoberte.": "La comparaison contient déjà 4 produits. Retirez-en un d’abord.",
      "Porovnanie zostane uložené v tomto prehliadači.": "La comparaison reste enregistrée dans ce navigateur.",
      "Vybraný je 1 produkt. Pridajte ešte aspoň jeden.": "1 produit sélectionné. Ajoutez au moins un autre produit.",
      "Na porovnanie sú pripravené {count} produkty.": "{count} produits prêts à être comparés.",
      "Naraz možno porovnať najviac 4 produkty.": "Vous pouvez comparer jusqu’à 4 produits à la fois.",
      "Produkt bol pridaný do porovnania.": "Le produit a été ajouté à la comparaison.",
      "Produkt bol z porovnania odobratý.": "Le produit a été retiré de la comparaison.",
      "Prehliadač neumožnil uložiť porovnanie. Skontrolujte nastavenia súkromia.": "Le navigateur n’a pas pu enregistrer la comparaison. Vérifiez vos paramètres de confidentialité.",
      "Prehliadač neumožnil vymazať uložené porovnanie.": "Le navigateur n’a pas pu effacer la comparaison enregistrée.",
      "Porovnanie bolo vymazané.": "La comparaison a été effacée.",
      "Prehliadač neumožnil zmeniť uložené porovnanie.": "Le navigateur n’a pas pu modifier la comparaison enregistrée."
    };
    var isFrench = String(document.documentElement.lang || "sk").toLowerCase().split("-")[0] === "fr";
    var result = isFrench && translations[source] ? translations[source] : source;
    return result.replace(/\{(title|count)\}/g, function (match, key) {
      return values && values[key] != null ? String(values[key]) : match;
    });
  }

  var COMPARISON_STORAGE_KEY = "teravia-product-comparison-v1";
  var MAX_COMPARISON_ITEMS = 4;

  function query(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function queryAll(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function asText(value) {
    return value == null ? "" : String(value).trim();
  }

  function positiveNumber(value) {
    var normalized = asText(value).replace(/\u00a0/g, " ").replace(",", ".").toLowerCase();
    var match = normalized.match(/^(\d+(?:\.\d+)?)\s*(?:cm)?$/i);
    if (!match) return null;

    var parsed = Number(match[1]);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function boundedWallDimension(input) {
    var value = positiveNumber(input && input.value);
    return value !== null && value <= 10000 ? value : null;
  }

  function formatNumber(value, maximumFractionDigits) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "sk-SK", {
        maximumFractionDigits: maximumFractionDigits == null ? 1 : maximumFractionDigits
      }).format(value);
    } catch (error) {
      return String(value);
    }
  }

  function formatMoneyFromCents(value) {
    var cents = Number(value);
    if (!Number.isFinite(cents)) return "";

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "EUR";

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "sk-SK", {
        style: "currency",
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + " " + currency;
    }
  }

  function setInvalid(input, invalid) {
    if (!input) return;
    input.setAttribute("aria-invalid", invalid ? "true" : "false");
  }

  function initializeWallCalculator(calculator) {
    if (!calculator || calculator.dataset.teraviaWallReady === "true") return;
    calculator.dataset.teraviaWallReady = "true";

    var form = query("[data-wall-calculator-form]", calculator);
    var wallWidthInput = query("[data-wall-width]", calculator);
    var wallHeightInput = query("[data-wall-height]", calculator);
    var calculateButton = query("[data-wall-calculate]", calculator);
    var sizeNote = query("[data-panel-size-note]", calculator);
    var result = query("[data-wall-calculator-result]", calculator);
    var countNode = query("[data-panel-count]", calculator);
    var breakdownNode = query("[data-panel-breakdown]", calculator);
    var areaNode = query("[data-panel-area]", calculator);
    var priceNode = query("[data-panel-price]", calculator);
    var applyButton = query("[data-panel-apply-quantity]", calculator);
    var quantityStatus = query("[data-panel-quantity-status]", calculator);
    var panelWidth = positiveNumber(calculator.dataset.panelWidth);
    var panelHeight = positiveNumber(calculator.dataset.panelHeight);
    var calculatedQuantity = null;

    if (!form || !wallWidthInput || !wallHeightInput || !calculateButton || !result) return;

    if (panelWidth === null || panelHeight === null) {
      calculateButton.disabled = true;
      calculateButton.setAttribute("aria-disabled", "true");
      if (sizeNote) {
        sizeNote.textContent = "V údajoch produktu chýba jednoznačný rozmer panelu. Kalkulačku preto nepoužívajte, kým si rozmer neoveríte pri parametroch alebo u nás.";
      }
    } else if (sizeNote) {
      sizeNote.textContent = "Kalkulačka počíta s panelom " + formatNumber(panelWidth) + " × " + formatNumber(panelHeight) + " cm.";
    }

    form.addEventListener("input", function (event) {
      result.hidden = true;
      calculatedQuantity = null;
      if (applyButton) applyButton.disabled = true;
      if (event.target instanceof HTMLInputElement) setInvalid(event.target, false);
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (panelWidth === null || panelHeight === null) return;

      var wallWidth = boundedWallDimension(wallWidthInput);
      var wallHeight = boundedWallDimension(wallHeightInput);
      var widthInvalid = wallWidth === null;
      var heightInvalid = wallHeight === null;

      setInvalid(wallWidthInput, widthInvalid);
      setInvalid(wallHeightInput, heightInvalid);
      result.hidden = false;

      if (widthInvalid || heightInvalid) {
        result.dataset.state = "error";
        if (countNode) countNode.textContent = "Zadajte platné rozmery steny.";
        if (breakdownNode) breakdownNode.textContent = "Každý rozmer musí byť kladné číslo od 1 do 10 000 cm.";
        if (areaNode) areaNode.textContent = "";
        if (priceNode) priceNode.textContent = "";
        (widthInvalid ? wallWidthInput : wallHeightInput).focus();
        return;
      }

      var across = Math.ceil(wallWidth / panelWidth);
      var high = Math.ceil(wallHeight / panelHeight);
      var total = across * high;

      if (!Number.isSafeInteger(total) || total < 1 || total > 9999) {
        result.dataset.state = "error";
        if (countNode) countNode.textContent = "Rozsah je príliš veľký na automatický výpočet.";
        if (breakdownNode) breakdownNode.textContent = "Pri projekte nad 9 999 panelov nás kontaktujte pre individuálny návrh.";
        if (areaNode) areaNode.textContent = "";
        if (priceNode) priceNode.textContent = "";
        return;
      }

      var requestedArea = wallWidth * wallHeight / 10000;
      var coveredArea = total * panelWidth * panelHeight / 10000;
      var unitPrice = Number(calculator.dataset.panelUnitPrice);
      calculatedQuantity = total;
      result.dataset.state = "calculated";

      if (countNode) countNode.textContent = "Potrebujete " + total + " " + (total === 1 ? "panel" : "panelov") + ".";
      if (breakdownNode) {
        breakdownNode.textContent = across + " na šírku × " + high + " na výšku (panel " + formatNumber(panelWidth) + " × " + formatNumber(panelHeight) + " cm).";
      }
      if (areaNode) {
        areaNode.textContent = "Zadaná plocha " + formatNumber(requestedArea, 2) + " m²; panely spolu pokryjú približne " + formatNumber(coveredArea, 2) + " m².";
      }
      if (priceNode) {
        priceNode.textContent = Number.isFinite(unitPrice) && unitPrice >= 0
          ? "Cena " + total + " ks pri aktuálnom variante: " + formatMoneyFromCents(total * unitPrice) + "."
          : "Aktuálnu cenu množstva sa nepodarilo vypočítať.";
      }
      if (applyButton) {
        applyButton.disabled = false;
        applyButton.textContent = "Použiť " + total + " ks v objednávke";
      }
    });

    if (applyButton) {
      applyButton.addEventListener("click", function () {
        if (!calculatedQuantity) return;
        var quantityInput = document.getElementById(calculator.dataset.quantityInputId);
        if (!quantityInput) return;

        quantityInput.value = String(calculatedQuantity);
        quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
        if (quantityStatus) quantityStatus.textContent = "Množstvo v objednávke bolo nastavené na " + calculatedQuantity + " kusov.";
        quantityInput.focus();
      });
    }

    var productRoot = calculator.closest(".botanicalis-product") || document;
    var variantSelect = query('select[name="id"]', productRoot);
    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (option && option.dataset.priceCents) calculator.dataset.panelUnitPrice = option.dataset.priceCents;
        result.hidden = true;
        calculatedQuantity = null;
        if (applyButton) applyButton.disabled = true;
      });
    }
  }

  function safeUrl(value, productOnly) {
    if (!value) return "";
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return "";
      if (productOnly && url.pathname.indexOf("/products/") === -1) return "";
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return "";
    }
  }

  function safeImageUrl(value) {
    if (!value) return "";
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol === "https:" || (url.protocol === "http:" && url.origin === window.location.origin)) return url.href;
    } catch (error) {
      return "";
    }
    return "";
  }

  function itemFromRoot(root) {
    return {
      id: asText(root.dataset.productId),
      variantId: asText(root.dataset.variantId),
      title: asText(root.dataset.productTitle) || "Produkt TERAVIA",
      type: asText(root.dataset.productType) || "Produkt",
      priceCents: asText(root.dataset.productPriceCents),
      price: asText(root.dataset.productPrice),
      height: asText(root.dataset.productHeight),
      width: asText(root.dataset.productWidth),
      shape: asText(root.dataset.productShape),
      image: safeImageUrl(root.dataset.productImage),
      url: safeUrl(root.dataset.productUrl, true)
    };
  }

  function sanitizeStoredItem(item) {
    if (!item || typeof item !== "object") return null;
    var id = asText(item.id);
    var title = asText(item.title);
    var url = safeUrl(item.url, true);
    if (!id || !title || !url) return null;

    return {
      id: id,
      variantId: asText(item.variantId),
      title: title,
      type: asText(item.type) || "Produkt",
      priceCents: asText(item.priceCents),
      price: asText(item.price),
      height: asText(item.height),
      width: asText(item.width),
      shape: asText(item.shape),
      image: safeImageUrl(item.image),
      url: url
    };
  }

  function readComparisonItems() {
    var stored;
    try {
      stored = JSON.parse(window.localStorage.getItem(COMPARISON_STORAGE_KEY) || "[]");
    } catch (error) {
      stored = [];
    }
    if (!Array.isArray(stored)) return [];

    var seen = new Set();
    return stored.map(sanitizeStoredItem).filter(function (item) {
      if (!item || seen.has(item.id)) return false;
      seen.add(item.id);
      return true;
    }).slice(0, MAX_COMPARISON_ITEMS);
  }

  function saveComparisonItems(items) {
    try {
      window.localStorage.setItem(COMPARISON_STORAGE_KEY, JSON.stringify(items.slice(0, MAX_COMPARISON_ITEMS)));
      return true;
    } catch (error) {
      return false;
    }
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }

  function addComparisonRow(body, label, items, renderValue) {
    var row = createElement("tr");
    var heading = createElement("th", "", label);
    heading.scope = "row";
    row.append(heading);

    items.forEach(function (item) {
      var cell = createElement("td");
      renderValue(cell, item);
      row.append(cell);
    });
    body.append(row);
  }

  function renderComparisonTable(container, items) {
    container.replaceChildren();
    if (items.length < 2) return;

    var table = createElement("table", "teravia-product-compare__table");
    var caption = createElement("caption", "botanicalis-sr-only", frenchCopy("Porovnanie produktov TERAVIA"));
    var head = createElement("thead");
    var headRow = createElement("tr");
    var propertyHeading = createElement("th", "", frenchCopy("Vlastnosť"));
    propertyHeading.scope = "col";
    headRow.append(propertyHeading);
    items.forEach(function (item) {
      var productHeading = createElement("th", "", item.title);
      productHeading.scope = "col";
      headRow.append(productHeading);
    });
    head.append(headRow);

    var body = createElement("tbody");
    addComparisonRow(body, frenchCopy("Fotografia"), items, function (cell, item) {
      if (!item.image) {
        cell.textContent = frenchCopy("Bez fotografie");
        return;
      }
      var image = createElement("img");
      image.src = item.image;
      image.alt = item.title;
      image.loading = "lazy";
      image.width = 220;
      image.height = 220;
      cell.append(image);
    });
    addComparisonRow(body, frenchCopy("Typ"), items, function (cell, item) { cell.textContent = item.type || "—"; });
    addComparisonRow(body, frenchCopy("Cena"), items, function (cell, item) { cell.textContent = item.price || "—"; });
    addComparisonRow(body, frenchCopy("Výška"), items, function (cell, item) { cell.textContent = item.height || "—"; });
    addComparisonRow(body, frenchCopy("Šírka / priemer"), items, function (cell, item) { cell.textContent = item.width || "—"; });
    addComparisonRow(body, frenchCopy("Silueta"), items, function (cell, item) { cell.textContent = item.shape || "—"; });
    addComparisonRow(body, frenchCopy("Akcia"), items, function (cell, item) {
      var link = createElement("a", "", frenchCopy("Otvoriť detail"));
      link.href = item.url;
      var remove = createElement("button", "", frenchCopy("Odobrať"));
      remove.type = "button";
      remove.dataset.productCompareRemove = item.id;
      remove.setAttribute("aria-label", frenchCopy("Odobrať {title} z porovnania", { title: item.title }));
      cell.append(link, remove);
    });

    table.append(caption, head, body);
    container.append(table);
  }

  function initializeProductComparison(root) {
    if (!root || root.dataset.teraviaCompareReady === "true") return;
    root.dataset.teraviaCompareReady = "true";

    var toggleButton = query("[data-product-compare-toggle]", root);
    var openButton = query("[data-product-compare-open]", root);
    var countNode = query("[data-product-compare-count]", root);
    var status = query("[data-product-compare-status]", root);
    var dialog = query("[data-product-compare-dialog]", root);
    var tableContainer = query("[data-product-compare-table]", root);
    var lastFocus = null;

    if (!toggleButton || !openButton || !dialog || !tableContainer) return;

    function currentItem() {
      return itemFromRoot(root);
    }

    function updateControls(message) {
      var items = readComparisonItems();
      var item = currentItem();
      var selected = items.some(function (saved) { return saved.id === item.id; });
      var full = !selected && items.length >= MAX_COMPARISON_ITEMS;

      toggleButton.setAttribute("aria-pressed", selected ? "true" : "false");
      toggleButton.disabled = full;
      toggleButton.textContent = frenchCopy(selected ? "Odobrať z porovnania" : "Pridať do porovnania");
      openButton.disabled = items.length < 2;
      openButton.setAttribute("aria-disabled", items.length < 2 ? "true" : "false");
      if (countNode) countNode.textContent = "(" + items.length + ")";

      if (status) {
        if (message) status.textContent = frenchCopy(message);
        else if (full) status.textContent = frenchCopy("V porovnaní sú už 4 produkty. Jeden najprv odoberte.");
        else if (items.length === 0) status.textContent = frenchCopy("Porovnanie zostane uložené v tomto prehliadači.");
        else if (items.length === 1) status.textContent = frenchCopy("Vybraný je 1 produkt. Pridajte ešte aspoň jeden.");
        else status.textContent = frenchCopy("Na porovnanie sú pripravené {count} produkty.", { count: items.length });
      }
      return items;
    }

    function closeDialog(restoreFocus) {
      if (dialog.hidden) return;
      dialog.hidden = true;
      dialog.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("teravia-product-compare-open");
      if (restoreFocus !== false && lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      lastFocus = null;
    }

    function openDialog() {
      var items = readComparisonItems();
      if (items.length < 2) return;
      lastFocus = document.activeElement;
      renderComparisonTable(tableContainer, items);
      dialog.hidden = false;
      dialog.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("teravia-product-compare-open");
      var closeButton = query(".teravia-product-compare__header [data-product-compare-close]", dialog);
      if (closeButton) closeButton.focus();
    }

    root.addEventListener("click", function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.closest("[data-product-compare-toggle]")) {
        var items = readComparisonItems();
        var item = currentItem();
        var index = items.findIndex(function (saved) { return saved.id === item.id; });
        var message;

        if (index === -1) {
          if (items.length >= MAX_COMPARISON_ITEMS) {
            updateControls("Naraz možno porovnať najviac 4 produkty.");
            return;
          }
          items.push(item);
          message = "Produkt bol pridaný do porovnania.";
        } else {
          items.splice(index, 1);
          message = "Produkt bol z porovnania odobratý.";
        }

        if (!saveComparisonItems(items)) {
          updateControls("Prehliadač neumožnil uložiť porovnanie. Skontrolujte nastavenia súkromia.");
          return;
        }
        updateControls(message);
        return;
      }

      if (target.closest("[data-product-compare-open]")) {
        openDialog();
        return;
      }

      if (target.closest("[data-product-compare-close]")) {
        closeDialog(true);
        return;
      }

      if (target.closest("[data-product-compare-clear]")) {
        if (!saveComparisonItems([])) {
          updateControls("Prehliadač neumožnil vymazať uložené porovnanie.");
          return;
        }
        closeDialog(false);
        updateControls("Porovnanie bolo vymazané.");
        toggleButton.focus();
        return;
      }

      var removeButton = target.closest("[data-product-compare-remove]");
      if (removeButton) {
        var remaining = readComparisonItems().filter(function (item) {
          return item.id !== removeButton.dataset.productCompareRemove;
        });
        if (!saveComparisonItems(remaining)) {
          updateControls("Prehliadač neumožnil zmeniť uložené porovnanie.");
          return;
        }
        updateControls("Produkt bol z porovnania odobratý.");
        if (remaining.length < 2) closeDialog(false);
        else renderComparisonTable(tableContainer, remaining);
      }
    });

    dialog.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeDialog(true);
        return;
      }
      if (event.key !== "Tab") return;

      var focusable = queryAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog)
        .filter(function (element) { return element.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    var productRoot = root.closest(".botanicalis-product") || document;
    var variantSelect = query('select[name="id"]', productRoot);
    if (variantSelect) {
      variantSelect.addEventListener("change", function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        if (!option) return;
        root.dataset.variantId = option.value;
        root.dataset.productPriceCents = option.dataset.priceCents || "";
        root.dataset.productPrice = option.dataset.priceFormatted || formatMoneyFromCents(option.dataset.priceCents);

        var items = readComparisonItems();
        var item = currentItem();
        var index = items.findIndex(function (saved) { return saved.id === item.id; });
        if (index !== -1) {
          items[index] = item;
          saveComparisonItems(items);
        }
        updateControls();
      });
    }

    window.addEventListener("storage", function (event) {
      if (event.key === COMPARISON_STORAGE_KEY) updateControls();
    });

    var initialItems = readComparisonItems();
    var initialCurrent = currentItem();
    var initialIndex = initialItems.findIndex(function (item) { return item.id === initialCurrent.id; });
    if (initialIndex !== -1) {
      initialItems[initialIndex] = initialCurrent;
      saveComparisonItems(initialItems);
    }

    updateControls();
  }

  function initialize() {
    queryAll("[data-teravia-wall-calculator]").forEach(initializeWallCalculator);
    queryAll("[data-teravia-product-compare]").forEach(initializeProductComparison);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
})();
